<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="orders.icon" class="mr-1"></i>
            <span>{{ orders.title }}</span>
          </b-col>
        </b-row>

        <b-tooltip target="refresh" triggers="hover">Click to refresh</b-tooltip>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Order" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="dateplaced" v-model="dateplaced_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        dateplaced_at = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref / PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="orders.debounce" placeholder="Your Ref" trim>
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :multiple="true" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested :disabled="readonly">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect placeholder="Select status..." v-model="status" :clearable="true"
                    :options="status_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested :disabled="readonly">
                    <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :multiple="true" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" :debounce="orders.debounce" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <div id="orders" class="px-3 mx-0 text-left">
          <div v-if="orders.pastespecial">
            <b-row class="mt-2" no-gutters>
              <b-col cols="6">
                <b-form-group>
                  <b-form-checkbox-group id="segments_paste_selected" v-model="orders.paste_selected"
                    :options="orders.paste_options" value-field="id" text-field="label"></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="auto" class="text-right ml-auto">
                <b-row>
                  <!-- <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col> -->
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="orders_saveit()">
                      <i class="fa fa-floppy-o"></i>
                      Save It
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="orders_headers()">
                      Headers
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="orders_paste_read()">
                      <i class="fa fa-magic"></i>
                      Read It
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label-cols="12">
                  <b-form-textarea id="data" v-model="orders.paste" placeholder="Paste order data" rows="6"
                    class="smalltextarea courier"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <d-table classdivtable="availtable datatable" refid="orders" :icon="orders.icon"
            :toolbarlibrary="orders.toolbarlibrary" :tools="orders.tools" :badges="orders.badges"
            :fields="orders.fields" :items="orders.items" :busy="orders.busy" :offset="orders.offset"
            :limit="orders.limit" :downloaded="orders.downloaded" :page="orders.page" :showpages="true"
            @click="orders_click" @select="orders_select" @load="orders_load">
          </d-table>
        </div>

      </div>

      <div v-show="component">
        <component :is="component" :selection="orders.selected" :config="cconfig" @discard="orders_click('discard')">
        </component>
      </div>
    </b-card>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import OrdersEdit from "./Components/OrdersEdit";
import OrdersInvoices from "./Components/OrdersInvoices";
import OrdersChart from "./Components/OrdersChart";
import OrdersTrack from "./Components/OrdersTrack";

function tabToObjArr(text) {

  let raw = text.trim().split('"').join("")
  let allcols = raw.split("\t")

  let headers = raw.split("\n")[0].split("\t")
  let cb = headers.length - 1
  let cols = []
  for (let i = 0; i < allcols.length; i++) {
    if (i == cb) {
      let parts = allcols[i].trim().split("\n")
      for (let k = 0; k < parts.length; k++) {
        cols.push(parts[k].trim())
      }
      cb += headers.length - 1
    } else {
      cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
    }
  }
  console.log('cols=', cols)

  cb = headers.length - 1
  let rows = []
  let item = {}
  let k = 0
  for (let i = 0; i < cols.length; i++) {
    if (i == cb) {
      item[headers[k]] = cols[i]
      rows.push(item)
      cb += headers.length
      item = {}
      k = 0
    } else {
      item[headers[k]] = cols[i]
      k += 1
    }
  }
  return rows;
}



export default {
  name: "Orders",
  components: {
    OrdersEdit,
    OrdersTrack,
    OrdersInvoices,
    OrdersChart,
  },
  async mounted() {
    this.accessdenied();
    await this.orders_load();
  },
  data() {
    return {
      busy: false,
      id: null,
      dateplaced_at: {
        startDate: this.$moment().startOf('year').format('YYYY-MM-DD'),
        endDate: this.$moment().endOf('year').format('YYYY-MM-DD')
      },
      slac: [],
      status: null,
      eventcode: [],
      yourref: null,
      agent: null,
      status_options: [
        { id: "0", label: "Complete" },
        { id: "1", label: "Active" },
        { id: "2", label: "Cancelled" },
      ],

      criteria: {
        events: [],
      },
      orders: {
        title: "Orders",
        icon: "fa fa-gavel",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        denied: [],
        toolbar: [],
        toolbarlibrary: [
          // {
          //   type: "button",
          //   size: "sm",
          //   variant: "outline-white",
          //   squared: "squared",
          //   icon: "fa fa-commenting-o",
          //   position: "toolbar",
          //   action: "notes",
          //   label: "Notes",
          //   component: {
          //     name: "",
          //   },
          // },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-binoculars text-purple",
            position: "toolbar",
            action: "track",
            label: "Track",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-check-square-o text-info mr-1",
            position: "toolbar",
            action: "complete",
            label: "Complete",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-thermometer-full text-danger mr-1",
            position: "toolbar",
            action: "allspent",
            label: "AllSpent",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-line-chart text-primary mr-1",
            position: "toolbar",
            action: "spent",
            label: "Spent",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-gbp text-primary",
            position: "toolbar",
            action: "invoices",
            label: "Invoices",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-pie-chart text-primary",
            position: "toolbar",
            action: "chart",
            label: "Chart",
            component: {
              name: "",
            },
          },
        ],
        edit: false,
        pastespecial: false,
        paste: null,
        paste_selected: ["firstrowheader", "reversenamecap"],
        paste_options: [
          { id: "firstrowheader", label: "First Row Headers", disabled: true },
          { id: "secondrowskip", label: "Second Row Skip" },
          { id: "filldown", label: "Fill Down" },
        ],
        tools: "go,filter,download,clipboard,add,edit,pastespecial,deleteconfirm,track,allspent,complete,invoices,spent,chart",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px text-primary",
          },
          {
            key: "placed_at",
            label: "Date",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            }
          },
          {
            key: "yourref",
            label: "Your Ref / PO",
            sortable: true,
            formatter: (value, key, item) => {
              let result = value;
              if (value.length >= 30) {
                result = value.slice(0, 27) + " ...";
              }
              return result;
            },
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          // {
          //   key: "eventcode",
          //   label: "Event",
          //   sortable: true,
          //   class: "d-none d-xl-table-cell",
          // },
          {
            key: "eventname",
            label: "Name",
            sortable: true,
            class: "d-none d-xl-table-cell",
            formatter: (value, key, item) => {
              if (value) {
                let result = value;
                if (value.length >= 30) {
                  result = value.slice(0, 27) + " ...";
                }
                return result;
              }
            },
          },
          {
            key: "value",
            label: "Value",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            totalled: true,
            total: 0,
          },
          {
            key: "spent",
            label: "Spent",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            totalled: true,
            total: 0,
          },
          {
            key: "reclaim",
            label: "Reclaim",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            totalled: true,
            total: 0,
          },
          {
            key: "remaining",
            label: "Remaining",
            sortable: true,
            class: "text-right d-none d-sm-table-cell",
            totalled: true,
            total: 0,
          },
          {
            key: "progress",
            label: "Progress%",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "used",
            label: "Used%",
            sortable: true,
            class: "d-none d-xl-table-cell",
            formatter: (value, key, item) => {
              let result = "0";
              if (item.spent && item.value) {
                if (parseFloat(item.spent) > 0 && parseFloat(item.value) > 0) {
                  result = ((parseFloat(item.spent) / parseFloat(item.value)) * 100).toFixed(2)
                }
              }
              return result;
            }
          },
          {
            key: "notify_limit",
            label: "Notify%",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "status",
            label: "Status",
            class: "d-none d-sm-table-cell",
            sortable: true,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-center actions w-80px",
          },
        ],
        badges: [
          {
            key: "progress",
            type: "progressbar",
            class: "warning",
          },
          {
            key: "status",
            type: "badge",
            Cancelled: "danger",
            Active: "success",
            Complete: "info",
            formatter: (value, key, item) => {
              switch (value) {
                case "0":
                  return "Complete";
                case "2":
                  return "Cancelled";
                case "1":
                  return "Active";
                default:
                  return value;
              }
            },
          },
          {
            key: "reason",
            type: "badge",
            other: "secondary",
            MEETING: "primary",
            ACCOMMODATION: "danger",
            "MEETING+ACCOMMODATION": "info",
            // formatter: (value, key, item) => {
            //   switch (value) {
            //     case "MEETING":
            //       return "Meeting";
            //     case "ACCOMMODATION":
            //       return "Accommodation";
            //     case "MEETING+ACCOMMODATION":
            //       return "Meeting+Accomodation";
            //     default:
            //       return value;
            //   }
            // },
          },
        ],
        items: [],
        downloaded: [],
        selected: [],
      },
    };
  },
  watch: {
    async dateplaced_at() {
      await this.orders_load(0);
    },
    async yourref() {
      this.dateplaced_at.startDate = null;
      this.dateplaced_at.endDate = null;
      this.agent = null;
      await this.orders_load(0);
    },
    async slac() {
      await this.orders_load(0);
    },
    async eventcode() {
      await this.orders_load(0);
    },
    async agent() {
      await this.orders_load(0);
    },
    async status() {
      await this.orders_load(0);
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log('window.width', newVal)
        let state = this.orders;
        if (newVal < 1550) {

          if (state.fields[15]) {
            state.fields[15].class = "d-none"
          }
          if (state.fields[16]) {
            state.fields[16].class = "d-none"
          }
        } else {

          if (state.fields[15]) {
            state.fields[15].class = "text-center"
          }
          if (state.fields[16]) {
            state.fields[16].class = "text-center"
          }
        }
      }
    },
  },

  computed: {
    readonly() {
      return this.user.rolename == "client";
    },
  },
  methods: {
    accessdenied() {
      this.orders.denied = [];
      if (!this.user.permissions.includes("orders.delete")) {
        this.orders.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("orders.save")) {
        this.orders.denied.push("save");
      }
    },
    async orders_load(offset, limit, page) {

      let state = this.orders;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      // NO WILDCARD SEARCHES
      if (
        !this.dateplaced_at.startDate &&
        !this.dateplaced_at.endDate &&
        !this.yourref &&
        !this.slac &&
        !this.eventcode &&
        !this.status &&
        !this.agent
      ) {
        return;
      }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        dateplaced_at: [
          this.dateplaced_at.startDate,
          this.dateplaced_at.endDate,
        ],
        //eventcode: this.eventcode,
        agent: this.agent,
        yourref: this.yourref,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        //slac: this.slac,
        status: this.status,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            # query orders(
            query orders(
              $limit: Int
              $offset: Int
              $id: String
              $dateplaced_at: [String]
              $slac: String
              $yourref: String
              $eventcode: String
              $agent: String
              $status: String
            ) {
              orders(
                limit: $limit
                offset: $offset
                id: $id
                dateplaced_at: $dateplaced_at
                yourref: $yourref
                slac: $slac
                eventcode: $eventcode
                agent: $agent
                status: $status
              ) {
                id
                yourref
                slac
                reason
                placed_at
                eventcode
                eventname
                value
                spent
                reclaim
                credit
                remaining
                notify_limit
                forecast
                forecast_on #needed for donuts
                notes
                status
                attachment
                agent
                updated_by
                updated_at
                rows
              }
            }
          `,
          variables,
        });

        if (limit == 0) {
          state.downloaded = this.cleanit(response.data.orders);
        } else {
          state.items = response.data.orders;
          for (var k = 0; k < this.orders.items.length; k++) {
            if (this.orders.items[k].value && this.orders.items[k].spent) {
              this.orders.items[k].progress = (
                (this.orders.items[k].spent / this.orders.items[k].value) *
                100
              ).toFixed(2);
            }
          }
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },


    async orders_select(ss, tools) {
      console.log("orders_select", ss);

      let state = this.orders;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "pastespecial", "track", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "invoices"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "complete", "chart", "allspent", "spent"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async orders_click(a, ss) {
      console.log("orders_click", a, ss);

      let state = this.orders;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.orders_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          this.orders_load(0);
          break;
        case "pastespecial":
          state.pastespecial = !state.pastespecial
          break;
        case "add":
          this.component = "OrdersEdit";
          break;
        case "edit":
          this.component = "OrdersEdit";
          await this.orders_load(0);
          break;
        // case "notes":
        //   this.component = "OrdersNotes";
        //   break;
        case "track":
          this.component = "OrdersTrack";
          await this.orders_load(0);
          break;
        case "invoices":
          this.component = "OrdersInvoices";
          break;
        case "allspent":
          await this.orders_allspent(ss);
          break;
        case "spent":
          await this.orders_spent(ss);
          break;
        case "delete":
          await this.orders_deleteit(ss);
          break;
        case "complete":
          await this.orders_completeit(ss);
          break;
        case "chart":
          this.component = "OrdersChart";
          break;
      }
    },

    async orders_paste_read() {

      let state = this.orders;

      if (state.paste) {
        state.busy = true
        let rows = tabToObjArr(state.paste)

        let rowstart = 1
        if (state.paste_selected.includes("secondrowskip")) {
          rowstart += 1
        }

        // MAKE OBJECT ITEMS
        let items = []
        for (let i = rowstart; i < rows.length; i++) {
          items.push(rows[i])
        }

        if (state.paste_selected.includes("filldown")) {
          let lastitem = {}
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            for (let prop in lastitem) {
              if (!item[prop]) {
                if (lastitem[prop]) {
                  item[prop] = lastitem[prop]
                }
              }
            }
            lastitem = item
          }
        }

        let found = null

        rows = []
        for (let i = 0; i < items.length; i++) {
          let obj = items[i]

          let order = {}

          for (let prop in obj) {

            let values = []
            try {
              if (obj[prop]) {
                let data = obj[prop].trim().toUpperCase()
                let colname = prop.toLowerCase()

                if (colname == 'description' || colname == 'name') {
                  order.description = data
                  order.eventname = data
                }
                if (colname == 'eventcode') {
                  order.eventcode = data
                }
                if (colname == 'slac') {
                  order.slac = data
                }
                if (colname == 'po' || colname == 'yourref') {
                  order.yourref = data.split("*")[0]
                  order.yourref = order.yourref.split('-0000').join('')
                  // ENDS WITH -
                  if (order.yourref.slice(-1) == '-') {
                    order.yourref = order.yourref.slice(0, order.yourref.length - 1)
                  }
                }
                if (colname == 'value') {
                  if (data) {
                    order.value = parseFloat(data).toFixed(2)
                  }
                }

              }

            } catch (error) {
              console.log('error here', error)
            }
          }
          // DE-DUPLICATE
          found = rows.find(o => o.yourref == order.yourref)
          if (!found) {
            rows.push(order)
          }
        }
        console.log('rows=', rows)

        state.items = rows

        state.busy = false
      }

    },
    async orders_headers() {

      let state = this.orders;

      let content = state.paste
      state.paste = "SLAC\tPO\n"
      if (content) {
        state.paste += content
      }
    },

    async orders_saveit() {
      console.log("orders_saveit");

      let state = this.orders;

      state.busy = true;

      let variables = { rows: this.cleanit(state.items) };
      console.log("variables", variables);


      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation orders_save($rows: [Order_input]) {
              orders_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      state.busy = false;

    },

    async orders_deleteit(ss) {
      console.log("orders_deleteit", ss);

      let state = this.orders;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation orders_delete($rows: [Order_input]) {
              orders_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      state.busy = false
      await this.orders_load();
    },

    async orders_allspent(ss, tools) {


      let state = this.orders;

      if (await this.$bvModal.msgBoxConfirm('Update the selected rows to value = spent ', {
        title: 'Are you sure you want to update to spent value ?',
        size: 'lg',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })) {

        state.busy = true

        let rows = [];
        ss.forEach(function (v) {
          rows.push({ id: v.id, value: v.spent });
        });
        let variables = {
          rows,

        };

        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation orders_save($rows: [Order_input]) {
              orders_save(rows: $rows) {
                id
              }
            }
          `,
            variables,
          });
          this.message = "<span class='text-primary'>Saved it.</span>";
        } catch (error) {
          this.message = "<span class='text-danger'>" + error.message + "</span>";
        }

        state.busy = false
      } else {
        state.busy = false
      }
      await this.orders_load(0);
    },
    async orders_spent(ss) {

      if (ss.length == 0) { return }

      this.orders.busy = true;

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });
      let variables = {
        selected: rows,

      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders_spent($selected: [Order_input]) {
              orders_spent(selected: $selected)
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      this.orders.busy = false;
      await this.orders_load();
    },

    async orders_download() {
      this.busy = true;
      let variables = {
        id: this.orders.selected[0].id,
        // documentformat: this.documentformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders($id: String) {
              orders(id: $id) {
                id
                data
              }
            }
          `,
          variables,
        });
        if (response.data.orders.length > 0) {
          if (response.data.orders[0].data) {
            try {
              this.fileUpload = JSON.parse(response.data.orders[0].data);
            } catch (error) {
              this.fileUpload = {
                name: response.data.orders[0].yourref + ".pdf",
                data: response.data.orders[0].data,
              };
            }
            await this.fileUpload_view();
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },

    async orders_completeit(ss) {
      console.log("completeit", ss);


      let state = this.orders;

      if (await this.$bvModal.msgBoxConfirm('Update the selected rows to completed ', {
        title: 'Are you sure you want to update to completed ?',
        size: 'lg',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })) {

        state.busy = true

        let rows = [];
        ss.forEach(function (v) {
          rows.push({ id: v.id, status: v.status == "0" ? "1" : "0" });
        });

        let variables = {
          rows,
        };

        console.log(variables);
        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation orders_save($rows: [Order_input], $dateformat: String) {
              orders_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
            variables,
          });

        } catch (error) {
          this.message = "<span class='text-danger'>" + error.message + "</span>";
        }
      } else {
        state.busy = false
      }
      await this.orders_load(0);
    },

  },
};
</script>

<style></style>